module.exports = __webpack_public_path__ + "tj.png?7cd7f67e0fde3ac069e1a49098cbd57b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tj.png
// module id = 39
// module chunks = 0